<div class="rotating-barcode" *ngIf="qrData">
  <div
    class="qr-frame {{ rotatingClass }}"
    [class.is-rotating]="rotating"
    [style.--sweep-duration]="sweepDuration"
  >
    <div class="qr-surface">
      <qrcode
        [qrdata]="qrData"
        [width]="127"
        [errorCorrectionLevel]="'M'"
        [elementType]="'svg'"
      ></qrcode>
    </div>
  </div>

  <span class="visually-hidden" aria-live="polite">{{ expiryMessage }}</span>
</div>
